// Module
var code = "<div layout=\"column\" class=\"md-padding\" layout-fill> <h2 class=\"md-title text-center\">Payment Required</h2> <div layout=\"row\" layout-align=\"center\"> <img class=\"error-img\" src=\"img/error/402.jpg\"/> </div> <p class=\"md-subhead text-center\"> Please contact the owner of this building to continue </p> </div> ";
// Exports
module.exports = code;